import { render, staticRenderFns } from "./ListRole.vue?vue&type=template&id=84b3a4a4&scoped=true"
import script from "./ListRole.vue?vue&type=script&lang=js"
export * from "./ListRole.vue?vue&type=script&lang=js"
import style0 from "./ListRole.vue?vue&type=style&index=0&id=84b3a4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b3a4a4",
  null
  
)

export default component.exports